import { render, staticRenderFns } from "./NationalPresidentFlagshipList.vue?vue&type=template&id=82c6ccdc"
import script from "./NationalPresidentFlagshipList.vue?vue&type=script&lang=js"
export * from "./NationalPresidentFlagshipList.vue?vue&type=script&lang=js"
import style0 from "./NationalPresidentFlagshipList.vue?vue&type=style&index=0&id=82c6ccdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports